import BResultsHealth from './BResultsHealth'

export default BResultsHealth
